import { render, staticRenderFns } from "./ColunaEsquerda.vue?vue&type=template&id=2a32dfbe&scoped=true&"
import script from "./ColunaEsquerda.vue?vue&type=script&lang=js&"
export * from "./ColunaEsquerda.vue?vue&type=script&lang=js&"
import style0 from "./ColunaEsquerda.vue?vue&type=style&index=0&id=2a32dfbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a32dfbe",
  null
  
)

export default component.exports